// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-v-dropdown.dropdown-toggle{padding:0}.custom-v-dropdown.dropdown-toggle:hover{text-decoration:none}.custom-v-dropdown.dropdown-toggle.dropdown-toggle-no-caret:after{content:none}.custom-v-dropdown.dropdown-menu{margin:0;padding:0;outline:none}.custom-v-dropdown.dropdown-menu .b-dropdown-text{padding:0}", ""]);
// Exports
module.exports = exports;
